import { Link } from 'react-router-dom';

export default function OfertaPage() {
  return (
    <div className="min-h-screen bg-[#F9F7F4]">
      {/* Шапка */}
      <div className="bg-[#1A2B4C] text-white py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors duration-200 text-sm font-['Montserrat'] mb-6 cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            На главную
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-['Playfair_Display'] text-white leading-tight">
            Публичная оферта на оказание услуг
          </h1>
          <p className="text-white/50 text-sm font-['Montserrat'] mt-3">
            Дата последней редакции: 01.01.2026
          </p>
        </div>
      </div>

      {/* Контент */}
      <div className="max-w-4xl mx-auto px-6 py-14">
        <div className="bg-white rounded-2xl p-8 md:p-12 space-y-10">

          {/* 1 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              1. Общие положения
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>1.1.</strong> Данный документ является официальным предложением (публичной офертой) Шарова Ирина Сергеевна ИНН 344700440103, именуемого в дальнейшем «Исполнитель», для любого физического или юридического лица (далее — «Заказчик»), которое примет настоящее предложение на указанных ниже условиях.
              </p>
              <p>
                <strong>1.2.</strong> Акцептом (принятием) данной оферты является полная или частичная оплата услуг Исполнителя или регистрация на сайте yoursystematicmarketing.com. С момента акцепта договор считается заключенным.
              </p>
            </div>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              2. Предмет договора
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>2.1.</strong> Исполнитель обязуется оказать услуги по системному маркетингу (включая, но не ограничиваясь: разработка стратегии, аудит, настройка рекламных кампаний, консультации), а Заказчик обязуется оплатить эти услуги в соответствии с Тарифами, оговоренными с Заказчиком.
              </p>
              <p>
                <strong>2.2.</strong> Конкретный перечень услуг, сроки и стоимость определяются выбранным Заказчиком тарифом или оформленным счетом.
              </p>
            </div>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              3. Порядок оказания услуг
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>3.1.</strong> Услуги оказываются дистанционно через сеть Интернет (Zoom, Skype, Email, мессенджеры: Телеграм, WhatsUp, MAX).
              </p>
              <p>
                <strong>3.2.</strong> Заказчик обязан предоставить Исполнителю всю необходимую информацию и доступы (к аналитике, рекламным кабинетам и т.д.), необходимые для качественного оказания услуг.
              </p>
              <p>
                <strong>3.3.</strong> Услуги считаются оказанными в полном объеме и принятыми Заказчиком, если в течение 3 (трех) рабочих дней по окончании оказания услуг от Заказчика не поступило мотивированных письменных возражений.
              </p>
            </div>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              4. Стоимость и порядок расчетов
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>4.1.</strong> Стоимость услуг индивидуально обговорена и зафиксирована с Заказчиком.
              </p>
              <p>
                <strong>4.2.</strong> Оплата производится на условиях 100% предоплаты, если иное не оговорено в выбранном тарифе.
              </p>
              <p>
                <strong>4.3.</strong> Все расчеты производятся в валюте удобной Заказчику (рубль, доллар, евро) электронными платежами через платежные системы, представленные на Сайте.
              </p>
            </div>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              5. Интеллектуальная собственность
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>5.1.</strong> Все методики, обучающие материалы, шаблоны и стратегии, предоставленные Исполнителем в процессе работы, являются интеллектуальной собственностью Исполнителя.
              </p>
              <p>
                <strong>5.2.</strong> Заказчику запрещается копировать, распространять или перепродавать материалы Исполнителя третьим лицам.
              </p>
            </div>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              6. Ответственность сторон
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>6.1.</strong> Исполнитель не несет ответственности за недостижение конкретных финансовых показателей Заказчика (прибыль, оборот), так как маркетинг зависит от множества факторов, включая рыночную конъюнктуру и действия самого Заказчика.
              </p>
              <p>
                <strong>6.2.</strong> Исполнитель гарантирует использование профессиональных знаний и инструментов для максимально эффективного оказания услуг.
              </p>
            </div>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              7. Политика возврата
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>7.1.</strong> Заказчик имеет право отказаться от услуг до начала их фактического оказания с возвратом оплаченной суммы за вычетом фактически понесенных расходов Исполнителя (комиссии платежных систем и т.д.).
              </p>
              <p>
                <strong>7.2.</strong> После начала оказания услуг (например, предоставления доступа к закрытым материалам или проведения первой консультации) возврат средств осуществляется пропорционально неоказанному объему услуг.
              </p>
            </div>
          </section>

          {/* 8 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              8. Персональные данные
            </h2>
            <div className="space-y-4 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed">
              <p>
                <strong>8.1.</strong> Акцептуя оферту, Заказчик дает согласие на обработку своих персональных данных в соответствии с Политикой конфиденциальности, размещенной на Сайте.
              </p>
            </div>
          </section>

          {/* 9 */}
          <section>
            <h2 className="text-xl font-bold font-['Playfair_Display'] text-[#1A2B4C] mb-4 pb-3 border-b border-[#C5A880]/30">
              9. Реквизиты исполнителя
            </h2>
            <div className="bg-[#F9F7F4] rounded-xl p-6 text-[#3A3A3A] text-sm font-['Montserrat'] leading-relaxed space-y-2">
              <p className="font-semibold text-[#1A2B4C]">Самозанятый Шарова Ирина Сергеевна</p>
              <p><span className="text-[#1A2B4C]/60">ИНН:</span> 344700440103</p>
              <p><span className="text-[#1A2B4C]/60">Адрес:</span> 109052, г Москва, Нижегородский р-н, Рязанский пр-кт, д 2/1 к 2, кв 76А</p>
              <div className="border-t border-[#C5A880]/20 pt-3 mt-3 space-y-2">
                <p className="font-semibold text-[#1A2B4C]">Банковские реквизиты:</p>
                <p><span className="text-[#1A2B4C]/60">р/с:</span> 40817810100016690389</p>
                <p><span className="text-[#1A2B4C]/60">Банк:</span> АО «ТБанк»</p>
                <p><span className="text-[#1A2B4C]/60">к/с:</span> 30101810145250000974</p>
                <p><span className="text-[#1A2B4C]/60">БИК:</span> 044525974</p>
              </div>
              <div className="border-t border-[#C5A880]/20 pt-3 mt-3">
                <p>
                  <span className="text-[#1A2B4C]/60">Email:</span>{' '}
                  <a href="mailto:sharova77@mail.ru" className="text-[#C5A880] hover:underline cursor-pointer">
                    sharova77@mail.ru
                  </a>
                </p>
              </div>
            </div>
          </section>

        </div>

        {/* Кнопка назад */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#1A2B4C] text-white px-8 py-3 rounded-lg hover:bg-[#1A2B4C]/80 transition-colors duration-200 text-sm font-['Montserrat'] cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
}
